import { render, staticRenderFns } from "./newGPCode.vue?vue&type=template&id=15736f54&scoped=true&"
import script from "./newGPCode.vue?vue&type=script&lang=ts&"
export * from "./newGPCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15736f54",
  null
  
)

export default component.exports